/* The steps of the open chapter. A step ahead of the cursor is disabled rather
   than hidden: the shape of the chapter is part of what it teaches. */
import { useTranslation } from 'react-i18next';
import { blockDone, curBlock } from '../../engine/progress';
import { useApp } from '../../state/AppProvider';
import type { NodeDef } from '../../types';

export function Stepper({ node }: { node: NodeDef }) {
  const { t } = useTranslation();
  const { progress, goBlock } = useApp();
  const current = curBlock(node, progress);

  return (
    <div className="stepper" data-od-id="block-stepper">
      {node.blocks.map((block, index) => {
        const done = blockDone(block, progress);
        const state = done ? 'done' : index === current ? 'cur' : 'wait';
        return (
          <button
            key={block.id}
            type="button"
            className="step"
            data-act="block"
            data-id={node.id}
            data-i={index}
            data-state={state}
            data-kind={block.kind}
            data-od-id={`step-${block.id}`}
            disabled={state === 'wait'}
            aria-disabled={state === 'wait' || undefined}
            aria-current={index === current ? 'step' : undefined}
            onClick={() => goBlock(node.id, index)}
          >
            <span className="sdot" />
            <span className="sn num">{('0' + (index + 1)).slice(-2)}</span>
            <span className="st">{t(block.titleKey)}</span>
            <span className="sm num">{done ? '✓' : `+${block.xp}`}</span>
          </button>
        );
      })}
    </div>
  );
}
